var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullscreenOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 41",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 14.8358V16.8358H16.0711V8.76471H14.0711V14.8358H8ZM32 26.6936V24.6936L23.9289 24.6936L23.9289 32.7647H25.9289V26.6936H32Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreenOff);
export default __webpack_public_path__ + "static/media/fullscreenOff.18ec28d120135eef2a717551657fcb2d.svg";
export { ForwardRef as ReactComponent };